<template>
<b-container style="max-width: 1200px !important">

<b-row class="justify-content-center align-items-center">
    <h5 style="text-align:center" >QUANTEEC x Brightcove</h5>
</b-row>
<b-row class="justify-content-center align-items-center">
        <p style="margin-bottom:0px" v-html="$ml.get('pluginp7')">
            
        </p>
</b-row>
<b-row class="justify-content-center align-items-center">
  <ol class="center" style="margin: 10px">
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp9')}}<br />
              <code>
                {{line1_bright}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line1_bright)" />
          </li>
          <li style="margin-bottom:10px">
              <span v-html="$ml.get('pluginp10')"></span><br />
              <code>{{line2_bright}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard('quanteec')" />
          </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp20')}}<br />
              <code>
                {{configLine}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
          </li>
          
  </ol>
</b-row>


    <b-row class="mt-2">
        <b-col cols="7">
            <b-row class="justify-content-center"><p v-html="$ml.get('brightcovecodep1')"></p></b-row>

            <b-row class="m-1 justify-content-around align-items-center">
                <b-img fluid-grow :src="require('@/assets/brightcove_plugins.svg')"></b-img>
            </b-row>

            <b-row class="m-1 justify-content-around align-items-center">
                <b-img fluid-grow :src="require('@/assets/brightcove_options.svg')"></b-img>
            </b-row>

        </b-col>

        <div v-if="$ml.current === 'EN'" class="col-5">
            <vue-markdown style="overflow: auto;"  @rendered="onrendered">
List of possible options to be inserted - according to your needs - on the Plugins section, under Name, Options (JSON)/plugin options (formatted as JSON)

``` javascript
{
    quanteecKey: "myquanteecKey", // [Mandatory] String --> used to verify the authorizations

    videoID: "videoID",// [Optional] String --> specific name to identify a video. Default: the videoSource value is used.
    withCredentials: true, // [Optional] Boolean --> sends the HTTP requests with credentials. Default: false.
    externalLive: true, // [Optional] Boolean --> used for detection of live interruption, by activating error detection.
    analytics: {
        analyticsVideoID: 'videoID',   // [Optional] String --> specific name to identify a video for the Analytics process. Default, videoID is used.
    },
    p2p: {
        activated: true, // [Optional] Boolean --> Activates QUANTEEC P2P system. Default: true
        tracker: "wss://tracker_url" // [Optional] String --> URL of the tracker. Uses the default according to the clientID, if not specified.
    }
};
```
[Contact us](mailto:support@quanteec.com) if you need some specific options
            </vue-markdown>
        </div>
        <div v-if="$ml.current === 'FR'" class="col-5">
            <vue-markdown style="overflow: auto;" @rendered="onrendered">
Liste des options qui peuvent être passées dans l'objet **configuration**, selon vos besoins. À ajouter dans la section Plugins, sous Name, Options (JSON)/plugin options (au format JSON) :

``` javascript
var configQuanteec = {
    quanteecKey: "myquanteecKey", // [Obligatoire] String --> utilisé pour vérifier les autorisations
    videoID: "videoID",// [Optionnel] String --> Nom spécifique pour identifier une vidéo. Par défaut : l'url de la vidéo est utilisé.
    withCredentials: true, // [Optionnel] Boolean --> Inclus les credentials dans les requêtes HTTP. Par défaut : false
    externalLive: true, // [Optionnel] Boolean --> utilisé pour détecter l'interruption des diffusions en direct.
    analytics: {
        analyticsVideoID: 'videoID',   // [Optionnel] String --> Nom spécifique utilisé pour identifier une vidéo dans les Analytics. Par défaut, le videoID est utilisé.
    },
    p2p: {
        activated: true, // [Optionnel] Boolean --> Active le système pair-à-pair de QUANTEEC. Par défaut: true
        tracker: "wss://tracker_url" // [Optionnel] String --> URL du tracker. Utilise par défaut celui rattaché à l'ID du client.
    }
};
```
[Contactez nous](mailto:support@quanteec.com) si vous avez besoin d'options spécifiques
            </vue-markdown>
        </div>
    </b-row>

<CopiedModal ref="copied"/>

</b-container>
</template>

<script>
import CopiedModal from '@/components/modals/CopiedModal.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Videojs',
  data: function() {
    return {
      line1_bright: 'https://quanteec.com/js/latest/videojs-quanteec-plugin.js',
      line2_bright: 'quanteec',
      line3_bright: '',
    }
  },
  props: [
      "streamKey",
    "configLine"
  ],
  components: {
      VueMarkdown,
      CopiedModal
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     onrendered() {
        Prism.highlightAll()
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>